import { FC } from 'react';
import { RadioInput } from 'src/components/form/radios';
import { Stack } from 'src/components/layout/stack';

const ReadOnlyOption: FC<{
  selected: boolean;
  children: JSX.Element;
  onClick?: () => void;
}> = ({ selected, onClick, children }) => {
  return (
    <Stack
      onClick={() => {
        if (!selected && onClick) {
          onClick();
        }
      }}
      gap={1}
      alignItems="baseline"
      templateColumns="50px 5fr"
    >
      <RadioInput showError={false} readOnly checked={selected} />
      <Stack gap={0}>{children}</Stack>
    </Stack>
  );
};

export default ReadOnlyOption;
